import { Application, ApplicationPaymentStatus, CaseStatus } from '@bybeam/platform-types';

export function formatCaseStatus(status: CaseStatus): string {
  switch (status) {
    case CaseStatus.InProgress:
      return 'In Progress';
    case CaseStatus.ReadyForReview:
      return 'Ready for Review';
    case CaseStatus.InReview:
      return 'In Review';
    case CaseStatus.PendingCertification:
      return 'Pending Certification';
    case CaseStatus.FiscalReview:
      return 'Fiscal Review';
    case CaseStatus.PaymentSent:
      return 'Payment Sent';
    case CaseStatus.Approved:
      return 'Approved';
    case CaseStatus.Archived:
      return 'Archive';
    default:
      return status;
  }
}

export function formatSimpleCaseStatus(status?: CaseStatus): string {
  switch (status) {
    case CaseStatus.Incomplete:
      return 'Incomplete';
    case CaseStatus.InProgress:
      return 'In Progress';
    case CaseStatus.ReadyForReview:
      return 'Awaiting Review';
    case CaseStatus.Withdrawn:
      return 'Withdrawn';
    case CaseStatus.Denied:
      return 'Denied';
    case CaseStatus.InReview:
    case CaseStatus.PendingCertification:
      return 'In Review';
    case CaseStatus.Approved:
    case CaseStatus.FiscalReview:
    case CaseStatus.PaymentSent:
      return 'Approved';
    default:
      return 'N/A';
  }
}

export function getApplicationPaymentStatus(application: Application): ApplicationPaymentStatus {
  if (application?.case?.status === 'Approved') {
    return ApplicationPaymentStatus.Unclaimed;
  }
  if (application?.case?.status === 'PaymentSent') {
    return ApplicationPaymentStatus.Paid;
  }
  if (application?.case?.fulfillments[0]?.payments[0]?.status === 'pending') {
    return ApplicationPaymentStatus.PaymentProcessing;
  }
  if (application?.case?.fulfillments[0]?.payments[0]?.status === 'failed') {
    return ApplicationPaymentStatus.Failed;
  }
  return ApplicationPaymentStatus.NA;
}

export function getCompletionStatus(application: Application): string {
  return application?.submittedAt ? 'Complete' : 'Incomplete';
}
